class TabsDesktop extends HTMLElement {
  constructor() {
    super();
    this.getNavbarItems = this.querySelectorAll('.tab-navigate');
    this.getTubs = this.querySelectorAll('.tab-item');
    this.getAllBtn = this.querySelectorAll('.tab-btn');
    this.getAllText = this.querySelectorAll('.tab-text')


    const dataClipboard = "Some copied data";

    this.getAllBtn.forEach(btn => {
      btn.addEventListener('click', async () => {
        this.showSuccess(btn)
        try {
          await navigator.clipboard.writeText(dataClipboard);
          console.log('Text copied to clipboard:', 'success');
        } catch (error) {
          console.error('Failed to copy text:', error);
        }
      })
    })

    this.getNavbarItems.forEach((item, index) => {

      item.addEventListener('click', () => {
        this.getNavbarItems.forEach(item => item.setAttribute('data-show', 'false'));
        this.getTubs.forEach(tub => tub.setAttribute('data-show', 'false'));
        item.setAttribute('data-show', 'true');
        this.getTubs[index]?.setAttribute('data-show', 'true');
      });
    });

    this.removeEmptyTabs();
  }

  showSuccess(btn) {
    let btnWidth = btn.clientWidth;
    btn.innerHTML =
      `<span>&#10004;</span>
    <span>Kopiert</span>`;
    btn.style.width = `${btnWidth}px`;
  }

  removeEmptyTabs() {
    this.getAllText.forEach((el, i) => {
      if (el.textContent.trim().length == 0) {
        this.getNavbarItems[i].style.display = 'none';
      }
    })
  }
}

customElements.define('tabs-desktop', TabsDesktop);